module.exports = __webpack_public_path__ + "static/media/menu-change-log.48731494.svg";